import { Subscribe } from "@react-rxjs/core"
import { useTranslation } from "react-i18next"

import { ErrorBoundary } from "@/App/Equities/shared/components"
import { useWatchlistInstruments } from "@/App/Equities/shared/services/watchlist"
import { Loader } from "@/components/Loader"

import { InstrumentsTable } from "./InstrumentsTable"
import { TRADE_PAGE_LOCATORS } from "./locators"

const FeaturedInstrumentsTable = () => {
  const instruments = useWatchlistInstruments()

  return (
    <InstrumentsTable
      instruments={instruments}
      data-testid={TRADE_PAGE_LOCATORS.featured}
    />
  )
}

export const FeaturedInstruments = () => {
  const { t } = useTranslation()

  return (
    <ErrorBoundary fallback={<div>{t("errorLoadingInstruments")}</div>}>
      <Subscribe fallback={<Loader />}>
        <FeaturedInstrumentsTable />
      </Subscribe>
    </ErrorBoundary>
  )
}
